import axios, { AxiosInstance } from 'axios';
import { config } from '../config';
import authService from './auth';

function isAllowedListUrl(url: string): boolean {
  const isHttp = /^https?:\/\//i.test(url);
  const isRootRelative = url.startsWith('/') && !url.startsWith('//');
  return (isHttp || isRootRelative) && url.length <= 2048;
}

class HttpListService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: config.apiBaseUrl,
      timeout: 15000,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    this.axiosInstance.interceptors.request.use(async (requestConfig) => {
      const hasValidToken = await authService.ensureValidToken();
      if (hasValidToken) {
        const token = authService.getCurrentToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      }
      return requestConfig;
    });
  }

  /** Authenticated GET of a JSON document. The caller chooses the path. */
  async getJson(url: string): Promise<unknown> {
    const trimmed = url.trim();
    if (!isAllowedListUrl(trimmed)) {
      throw new Error('URL is not allowed.');
    }
    const response = await this.axiosInstance.get<unknown>(trimmed);
    return response.data;
  }
}

const httpListService = new HttpListService();
export default httpListService;
